import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

const StatBarItemSlim = ({
  label, value, valueAffix, tooltip,
}) => (
  <div className="flex items-center text-[--secondary900] font-medium text-[0.875rem]">
    <div className="">{label}</div>
    <div className="text-[--secondaryText] text-base font-bold ml-2">
      <span className="">
        {tooltip ? (
          <Tooltip title={tooltip}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          <span>{value}</span>
        )}
      </span>
      <span className="">
        {valueAffix !== null ? `(${valueAffix})` : ''}
      </span>
    </div>
  </div>
);

StatBarItemSlim.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  valueAffix: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tooltip: PropTypes.string,
};

StatBarItemSlim.defaultProps = {
  label: null,
  tooltip: null,
  value: '-',
  valueAffix: null,
};

export default StatBarItemSlim;
